// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --color: #000;
  --app-max-content-width: 1440px;
  --app-header-max-width: 1920px;
}

:root {
  --color: #000;
  --app-max-content-width: 1440px;
  --app-header-max-width: 1920px;
}

.pac-container {
  z-index: 1400 !important;
}

html, body {
  overflow-x: hidden;
  overflow-y: hidden;
}

body {
  margin: 0;
  background-color: #F7F7F8;
}

.app-content-shell {
  max-width: var(--app-max-content-width);
  width: 100%;
  margin: 0 auto;
}

/* Global scrollbar styling — repaints the native browser scrollbar to match the
   dashboard's custom scrollbar look (see .custom-scrollbar-track/-thumb in
   dashboard.scss) without replacing native scroll behavior, so keyboard nav,
   touch/trackpad momentum, and accessibility all keep working as normal.
   Track is transparent so only the thumb itself is visible, floating over
   the page content instead of showing a solid gray bar. */
@supports not selector(::-webkit-scrollbar) {
  html {
    scrollbar-width: thin !important;
    scrollbar-color: #8e8e9a transparent !important;
  }
}
html::-webkit-scrollbar,
body::-webkit-scrollbar,
*::-webkit-scrollbar {
  width: 8px !important;
  height: 4px !important;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
*::-webkit-scrollbar-track {
  background: transparent !important;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
*::-webkit-scrollbar-thumb {
  background-color: #8e8e9a !important;
  border-radius: 999px !important;
  cursor: pointer;
  border: 1px solid transparent;
  background-clip: padding-box;
  transition: background-color 0.15s ease;
}
html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover,
*::-webkit-scrollbar-thumb:hover {
  background-color: #6e6e77 !important;
  border-width: 0;
}

.outlined-text-field {
  position: relative;
}
.outlined-text-field .MuiInputLabel-root {
  font-size: 12px;
  color: #14151C;
  -webkit-transform: none;
  transform: none;
  position: relative;
}
.outlined-text-field .MuiInputBase-root.Mui-error {
  color: #D84315;
}
.outlined-text-field .MuiInputBase-root input[type=text].MuiInputBase-input {
  color: #696F88;
  font-size: 12px;
  padding: 6.5px 12px;
  background-color: #fff;
  border-radius: 8px;
}
.outlined-text-field .MuiInputBase-root input[type=text].MuiInputBase-input.MuiInputBase-inputAdornedEnd {
  font-size: 14px;
}
.outlined-text-field .MuiInputBase-root input[type=text]::placeholder {
  color: #696F88;
}
.outlined-text-field .MuiFormHelperText-root {
  margin-top: 0px;
}
.outlined-text-field .MuiInputAdornment-root {
  cursor: pointer;
}
.outlined-text-field .MuiInputAdornment-root .MuiInputBase-root {
  height: 37px !important;
}
.outlined-text-field .MuiInputAdornment-root.MuiInputAdornment-positionStart {
  border-right: 1px solid #ccc;
  height: 46px;
  padding-right: 15px;
  margin: 0px;
}
.outlined-text-field input:-webkit-autofill,
.outlined-text-field input:-webkit-autofill:hover,
.outlined-text-field input:-webkit-autofill:focus,
.outlined-text-field ::-webkit-scrollbar {
  width: 100%;
}
.outlined-text-field input:-webkit-autofill,
.outlined-text-field input:-webkit-autofill:hover,
.outlined-text-field input:-webkit-autofill:focus,
.outlined-text-field input:-webkit-autofill:active {
  -webkit-background-clip: text;
  -webkit-text-fill-color: #696F88;
  transition: background-color 5000s ease-in-out 0s;
  box-shadow: inset 0 0 20px 20px #fff;
}

.signup_feilds .outlined-text-field .MuiInputLabel-root {
  font-size: 12px;
}
.signup_feilds .labelName {
  font-size: 12px;
}

.select-dropdown {
  width: 314px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 0;
  opacity: 1;
}
.select-dropdown .MuiAutocomplete-root {
  width: 100%;
}
.select-dropdown .MuiAutocomplete-root .MuiInputBase-root {
  align-items: center;
  padding: 4px 6px;
}
.select-dropdown .MuiAutocomplete-root .MuiInputBase-input {
  padding: 7px 12px;
}
.select-dropdown .MuiInputBase-formControl .MuiSelect-select {
  font-size: 15px;
  color: #696F88;
}
.select-dropdown .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-formControl {
  font-size: 12px;
  color: #696F88;
  background-color: #fff;
  padding: 4px 6px;
}
.select-dropdown .Mui-error {
  margin: 0px;
}
.select-dropdown .error {
  color: #D84315;
}

.search_feild .MuiInputBase-colorPrimary {
  border: 1px solid #E2E7EB;
  border-radius: 4px;
  padding: 3px 6px;
  max-width: 280px;
}
.search_feild .MuiInputBase-colorPrimary::before {
  border-style: none !important;
}
.search_feild .MuiInputBase-colorPrimary::after {
  border-style: none !important;
}
.search_feild .MuiInputBase-colorPrimary svg {
  padding-left: 5px;
}
.search_feild .MuiInputBase-colorPrimary input {
  font-size: 12px;
  color: #696F88 !important;
  padding: 3px 0 3px;
}
.search_feild .MuiInputBase-colorPrimary input::placeholder {
  color: #696F88 !important;
  opacity: 0.9;
  letter-spacing: 0.1px;
  font-size: 12px;
}

.date-container .date-picker-styles {
  margin: 0px !important;
  background: #fff;
}
.date-container .date-picker-styles .MuiInputBase-input {
  padding: 6px 14px;
  font-size: 12px;
  color: #696F88;
  border-radius: 8px;
}
.date-container .date-picker-styles .MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-color: #A3A9B9;
}
.date-container .date-picker-styles .MuiInputBase-root .MuiInputAdornment-root.MuiInputAdornment-positionEnd .MuiIconButton-root {
  padding: 0px;
}
.date-container .date-picker-styles.disable-fields .MuiOutlinedInput-notchedOutline {
  background: rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.6);
}
.date-container .MuiFormControl-root {
  position: relative;
}
.date-container .MuiFormControl-root .clear-date {
  display: none;
}
.date-container .MuiFormControl-root:hover .clear-date {
  display: block;
  position: absolute;
  right: 36px;
  background: transparent;
}
@media only screen and (min-width: 1026px) {
  .date-container .MuiFormControl-root:hover .clear-date {
    bottom: -1px;
  }
}
@media only screen and (min-width: 1022px) and (max-width: 1025px) {
  .date-container .MuiFormControl-root:hover .clear-date {
    bottom: 3px;
  }
}

.btn-txt {
  text-transform: capitalize !important;
}

.btn-txt-capitalize {
  text-transform: capitalize !important;
}

.MuiDialogActions-root .MuiButton-root {
  min-height: 40px;
  height: 40px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  text-transform: none;
}

.reset_password {
  color: #232630;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
  padding-top: 32px;
}
.reset_password ul li {
  margin: 5px 0px;
}
.reset_password ul li svg {
  position: relative;
  top: 5px;
  margin-left: 5px;
  font-size: 17px;
}

.email-password-success-header {
  color: black;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  word-wrap: break-word;
  padding-bottom: 16px;
  align-items: flex-start;
}

.email-password-success-content {
  color: #696F88;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
  padding-bottom: 32px;
}

.filtr-date-pkr .MuiStack-root {
  overflow: hidden;
}
.filtr-date-pkr .MuiStack-root .MuiTypography-root {
  font-size: 12px;
  font-weight: 400;
}

.signup_date .MuiStack-root .MuiTypography-root {
  font-size: 12px;
}

.custom-select-container .mui-selector {
  height: 40px;
}
.custom-select-container .mui-selector .MuiSelect-select {
  font-size: 14px;
  color: #696F88;
  padding: 9.5px 14px;
}
.custom-select-container .mui-selector .MuiSelect-select p {
  font-size: 14px;
  color: #696F88;
}

.filtr-search .MuiInputBase-root .MuiOutlinedInput-input {
  padding: 8px 14px;
}

.MuiPopover-paper .MuiMenu-list .select-lebel-text {
  font-size: 14px;
}

.custom-menu-class .MuiPaper-root .MuiList-root .MuiMenuItem-root {
  white-space: break-spaces;
}

.message-error {
  height: 20%;
  top: 8px;
  max-width: 400px;
  left: 38% !important;
  right: 20% !important;
}

.disable-fields {
  cursor: not-allowed;
}

.cstBlocksInfo, .cstBlocks {
  background: #fff;
  margin-top: 0.5rem;
  border-radius: 4px;
  padding: 0.75rem 1.125rem;
}
.cstBlocksInfo .MuiInputBase-root input[type=password], .cstBlocks .MuiInputBase-root input[type=password] {
  padding: 4px 14px;
}

.cstContactInfo .select-dropdown .cstInfoIcon {
  top: 21px;
}

@media screen and (max-width: 1024px) {
  .outlined-text-field .MuiInputLabel-root {
    font-size: 14px;
  }
  .outlined-text-field .MuiInputBase-root input[type=text].MuiInputBase-input {
    font-size: 14px;
    padding: 10px 12px;
  }
  .select-dropdown .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-formControl {
    padding: 6px;
  }
  .date-container .date-picker-styles .MuiInputBase-input {
    padding: 9.5px 14px;
  }
  .filtr-date-pkr .MuiTypography-root {
    font-size: 14px;
  }
  .select-dropdown .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-formControl {
    font-size: 15px;
    padding: 7.5px 6px;
  }
  .search_feild .MuiInputBase-colorPrimary input {
    font-size: 14px;
  }
  .search_feild .MuiInputBase-colorPrimary input::placeholder {
    font-size: 14px;
  }
  .date-container .date-picker-styles .MuiInputBase-input {
    font-size: 14px;
  }
}
@media screen and (max-width: 520px) {
  .cstInfoIcon {
    top: 27px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/form_styles.scss","webpack://./src/assets/scss/variable.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI,aAAA;EAKA,+BAAA;EAMA,8BAAA;ADPJ;;ACLA;EACI,aAAA;EAKA,+BAAA;EAMA,8BAAA;ADDJ;;AAPA;EACI,wBAAA;AAUJ;;AAIA;EACI,kBAAA;EACA,kBAAA;AADJ;;AAIA;EAMI,SAAA;EACA,yBCbM;ADOV;;AAqBA;EACI,uCAAA;EACA,WAAA;EACA,cAAA;AAlBJ;;AAsBA;;;;;0DAAA;AAaA;EACE;IACI,gCAAA;IACA,+CAAA;EA1BJ;AACF;AAkCA;;;EAOI,qBAAA;EACA,sBAAA;AApCJ;;AAuCE;;;EAGE,kCAAA;AApCJ;;AAuCE;;;EAGE,oCAAA;EACA,+BAAA;EACA,eAAA;EAKA,6BAAA;EACA,4BAAA;EAKA,uCAAA;AA5CJ;AA6CI;;;EACI,oCAAA;EACA,eAAA;AAzCR;;AA8CA;EACI,kBAAA;AA3CJ;AA6CI;EACI,eAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AA3CR;AA+CQ;EACI,cAAA;AA7CZ;AAiDY;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA/ChB;AAgDgB;EACI,eCnGV;ADqDV;AAsDY;EACI,cCjIH;AD6Eb;AAyDI;EACI,eAAA;AAvDR;AAgEI;EACI,eAAA;AA9DR;AAgEQ;EACI,uBAAA;AA9DZ;AAiEQ;EACI,4BAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AA/DZ;AAmEI;;;;EAII,WAAA;AAjER;AAoEI;;;;EAII,6BAAA;EACA,gCC3KK;ED4KL,iDAAA;EACA,oCAAA;AAlER;;AAuEQ;EACI,eAAA;AApEZ;AAuEI;EACI,eAAA;AArER;;AAwEA;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;AArEJ;AAuEI;EACI,WAAA;AArER;AAuEQ;EAGI,mBAAA;EACA,gBAAA;AAvEZ;AA0EQ;EACI,iBAAA;AAxEZ;AA6EQ;EACI,eC9LF;ED+LE,cCrNC;AD0Ib;AAiFY;EACI,eAAA;EACA,cC7NH;ED8NG,sBAAA;EACA,gBAAA;AA/EhB;AA0FI;EACI,WAAA;AAxFR;AA2FI;EACI,cC5OA;ADmJR;;AA+FI;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA5FR;AA8FQ;EACI,6BAAA;AA5FZ;AA+FQ;EACI,6BAAA;AA7FZ;AAgGQ;EACI,iBAAA;AA9FZ;AAiGQ;EACI,eAAA;EACA,yBAAA;EACA,kBAAA;AA/FZ;AAgGY;EACI,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AA9FhB;;AAqGI;EACI,sBAAA;EACA,gBAAA;AAlGR;AAmGQ;EACI,iBAAA;EACA,eCxQF;EDyQE,cC5RC;ED6RD,kBAAA;AAjGZ;AAoGY;EACI,qBCnSH;ADiMb;AAqGgB;EACI,YAAA;AAnGpB;AAwGY;EACI,8BAAA;EACA,yBAAA;AAtGhB;AA2GI;EACI,kBAAA;AAzGR;AA0GQ;EACI,aAAA;AAxGZ;AA4GY;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AA1GhB;AA2GgB;EALJ;IAMI,YAAA;EAxGd;AACF;AAyGgB;EARJ;IASI,WAAA;EAtGd;AACF;;AA6GA;EACI,qCAAA;AA1GJ;;AA6GA;EACI,qCAAA;AA1GJ;;AA8GI;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA3GR;;AA+GA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AA5GJ;AA+GQ;EACI,eAAA;AA7GZ;AA+GY;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AA7GhB;;AAmHA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,uBAAA;AAhHJ;;AAmHA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;AAhHJ;;AAoHI;EACI,gBAAA;AAjHR;AAmHQ;EACI,eAAA;EACA,gBAAA;AAjHZ;;AAyHQ;EACI,eAAA;AAtHZ;;AA2HI;EACI,YAAA;AAxHR;AA0HQ;EAMI,eC7YF;ED8YE,cCnaC;EDoaD,mBAAA;AA7HZ;AAsHY;EACI,eCzYN;ED0YM,cC/ZH;AD2Sb;;AAgIQ;EACI,iBAAA;AA7HZ;;AAoIQ;EACI,eC/ZF;AD8RV;;AAyIQ;EACE,yBAAA;AAtIV;;AA2IA;EACI,WAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AAxIJ;;AAiJA;EAEI,mBAAA;AA/IJ;;AAuKA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AApKJ;AAsKQ;EACI,iBAAA;AApKZ;;AA0KQ;EACI,SAAA;AAvKZ;;AA2KA;EAEQ;IACI,eAAA;EAzKV;EA6Kc;IACI,eAAA;IACA,kBAAA;EA3KlB;EAmLc;IACI,YAAA;EAjLlB;EAwLU;IACI,mBAAA;EAtLd;EA2LM;IACI,eAAA;EAzLV;EAgMc;IACI,eC9gBV;ID+gBU,kBAAA;EA9LlB;EAqMU;IACI,eAAA;EAnMd;EAoMc;IACI,eAAA;EAlMlB;EAyMU;IACI,eCliBN;ED2VR;AACF;AA2MA;EACI;IACI,oBAAA;EAzMN;AACF","sourcesContent":["@import './mixins.scss';\n@import './variable.scss';\n\n// Google Maps autocomplete dropdown must appear above MUI Dialogs (z-index 1300)\n.pac-container {\n    z-index: 1400 !important;\n}\n\n// `100vw` (used by .version-wrapper-dashboard's full-bleed breakout, see dashboard.scss) measures\n// the viewport including the vertical scrollbar's width, which is wider than the actual visible\n// area on any page with a body-level scrollbar — the difference shows up as unwanted horizontal\n// scroll. html/body never intentionally scroll horizontally in this app, so clipping it here is\n// a safe, standard guard rather than a workaround for a real content overflow.\n//\n// overflow-y is clipped too: every authenticated page owns a single inner container that fills\n// the viewport (height: calc(100dvh - 64px), its own overflowY: auto) and scrolls itself — the\n// outer html/body element is never meant to scroll at all. Without this, the outer page could\n// still grow taller than the viewport by a stray pixel or two (rounding, a border, etc.) and pop\n// up a second, redundant scrollbar alongside that inner container's own one.\nhtml, body {\n    overflow-x: hidden;\n    overflow-y: hidden;\n}\n\nbody {\n    // Browsers default <body> to an 8px margin on every side. Nothing in this app resets it (no\n    // CssBaseline, no global reset), so the page's real height is always 16px taller than the\n    // viewport — invisible on most pages, but on ones whose own content container also scrolls\n    // internally (overflowY: auto with a fixed height), it shows up as a second, outer scrollbar\n    // stacked next to that container's own one.\n    margin: 0;\n    background-color: $page_bg;\n    // @media (min-width: 1200px), (min-width: 960px) and (-webkit-device-pixel-ratio: 1.5) {\n    //     /* Add Styles Here */\n    //     zoom: 0.8;\n    // }\n    // @media (min-width: 1200px), (min-width: 960px) and (-webkit-device-pixel-ratio: 1.25) {\n    //     /* Add Styles Here */\n    //     zoom: 1;\n    // }\n}\n\n// Caps every authenticated page's content at --app-max-content-width (see variable.scss) and\n// centers it; space beyond that width shows the body background above instead of stretching\n// the content edge-to-edge on ultra-wide viewports. Applied in core/authentication.tsx, the\n// single shared shell wrapping every authenticated route's content.\n.app-content-shell {\n    max-width: var(--app-max-content-width);\n    width: 100%;\n    margin: 0 auto;\n}\n\n\n/* Global scrollbar styling — repaints the native browser scrollbar to match the\n   dashboard's custom scrollbar look (see .custom-scrollbar-track/-thumb in\n   dashboard.scss) without replacing native scroll behavior, so keyboard nav,\n   touch/trackpad momentum, and accessibility all keep working as normal.\n   Track is transparent so only the thumb itself is visible, floating over\n   the page content instead of showing a solid gray bar. */\n// scrollbar-width only accepts the keywords auto/thin/none — no custom pixel value — and\n// modern Chrome/Edge now implement this standard property natively, prioritizing it over the\n// legacy ::-webkit-scrollbar pixel-width styling below whenever both are present. That silently\n// capped every scrollbar at Chrome's fixed \"thin\" size regardless of the 2px we asked for via\n// ::-webkit-scrollbar. Scoping this to browsers that DON'T support ::-webkit-scrollbar (i.e.\n// Firefox) keeps Firefox's thin/colored scrollbar while letting Chrome/Edge/Safari fall through\n// to the pixel-precise webkit rules instead of overriding them.\n@supports not selector(::-webkit-scrollbar) {\n  html {\n      scrollbar-width: thin !important;\n      scrollbar-color: #8e8e9a transparent !important;\n  }\n}\n\n// The root/viewport scrollbar (the page's own outer scroll, as opposed to an inner\n// overflow:auto div) isn't reliably matched by a universal `*` selector in Chrome/Safari —\n// it has to be targeted on html/body explicitly, or the browser falls back to its default\n// width for it even though `*::-webkit-scrollbar` below correctly styles every other\n// scrollable element on the page.\nhtml::-webkit-scrollbar,\nbody::-webkit-scrollbar,\n*::-webkit-scrollbar {\n    // Track width stays fixed at the hover (max) size — the thumb itself is inset from it via\n    // a transparent border below, so hovering never changes this width/the reserved gutter\n    // space (which would otherwise shift layout by a couple px every time the pointer enters\n    // a scrollable area).\n    width: 8px !important;\n    height: 4px !important;\n  }\n\n  html::-webkit-scrollbar-track,\n  body::-webkit-scrollbar-track,\n  *::-webkit-scrollbar-track {\n    background: transparent !important;\n  }\n\n  html::-webkit-scrollbar-thumb,\n  body::-webkit-scrollbar-thumb,\n  *::-webkit-scrollbar-thumb {\n    background-color: #8e8e9a !important;\n    border-radius: 999px !important;\n    cursor: pointer;\n    // Thins the visible thumb to 8px by clipping 1px off each side (background-clip strips the\n    // background out of the border area), leaving it inset within the fixed 10px track. On\n    // hover, dropping the border back to 0 lets the thumb fill the full track width (10px) —\n    // a visual \"thicken\" that only touches the thumb's own border, not the track's width.\n    border: 1px solid transparent;\n    background-clip: padding-box;\n    // border-width is intentionally left untransitioned: it's a layout-affecting property, and\n    // the thumb itself moves under a stationary cursor during active scrolling — animating a\n    // layout property on every resulting hover toggle adds reflow work right when the browser\n    // is already handling scroll, compounding jank on rapid direction changes.\n    transition: background-color 0.15s ease;\n    &:hover{\n        background-color: #6e6e77 !important;\n        border-width: 0;\n    }\n  }\n\n// outlined text field\n.outlined-text-field {\n    position: relative;\n\n    .MuiInputLabel-root {\n        font-size: 12px;\n        color: #14151C;\n        -webkit-transform: none;\n        transform: none;\n        position: relative;\n    }\n\n    .MuiInputBase-root {\n        &.Mui-error {\n            color: #D84315;\n        }\n\n        input[type=\"text\"] {\n            &.MuiInputBase-input {\n                color: #696F88;\n                font-size: 12px;\n                padding: 6.5px 12px;\n                background-color: #fff;\n                border-radius: 8px;\n                &.MuiInputBase-inputAdornedEnd {\n                    font-size: $font_14;\n                }\n                &.Mui-disabled{\n                    // background: rgb(0 0 0 / 10%);\n                    // color: rgb(0 0 0 / 60%);\n                }\n            }\n\n            &::placeholder {\n                color: $input_text;\n            }\n        }\n    }\n\n    .MuiFormHelperText-root {\n        margin-top: 0px;\n\n        // &.Mui-error {\n        //     position: absolute;\n        //     bottom: -22px;\n        // }\n    }\n\n\n    .MuiInputAdornment-root {\n        cursor: pointer;\n\n        .MuiInputBase-root {\n            height: 37px !important;\n        }\n\n        &.MuiInputAdornment-positionStart {\n            border-right: 1px solid #ccc;\n            height: 46px;\n            padding-right: 15px;\n            margin: 0px;\n        }\n    }\n\n    input:-webkit-autofill,\n    input:-webkit-autofill:hover,\n    input:-webkit-autofill:focus,\n    ::-webkit-scrollbar {\n        width: 100%;\n    }\n\n    input:-webkit-autofill,\n    input:-webkit-autofill:hover,\n    input:-webkit-autofill:focus,\n    input:-webkit-autofill:active {\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: $input_text;\n        transition: background-color 5000s ease-in-out 0s;\n        box-shadow: inset 0 0 20px 20px #fff;\n    }\n}\n.signup_feilds{\n    .outlined-text-field {\n        .MuiInputLabel-root {\n            font-size: 12px;\n        }\n    }\n    .labelName{\n        font-size: 12px;\n    }\n}\n.select-dropdown {\n    width: 314px;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding-top: 0;\n    opacity: 1;\n\n    .MuiAutocomplete-root {\n        width: 100%;\n\n        .MuiInputBase-root {\n            // min-height: 40px;\n            // height: 40px;\n            align-items: center;\n            padding: 4px 6px;\n        }\n\n        .MuiInputBase-input {\n            padding: 7px 12px;\n        }\n    }\n\n    .MuiInputBase-formControl {\n        .MuiSelect-select {\n            font-size: $font_15;\n            color: $input_text;\n        }\n    }\n\n    .MuiAutocomplete-root {\n        .MuiFormControl-root {\n            .MuiInputBase-formControl {\n                font-size: 12px;\n                color: $input_text;\n                background-color: #fff;\n                padding: 4px 6px;\n                &.Mui-disabled{\n                    .MuiOutlinedInput-notchedOutline{\n                        // background: rgb(0 0 0 / 10%);\n                        // color: rgb(0 0 0 / 60%);\n                    }\n                }\n            }\n        }\n    }\n\n    .Mui-error {\n        margin: 0px;\n    }\n\n    .error {\n        color: $error;\n    }\n}\n\n// search field\n.search_feild {\n    .MuiInputBase-colorPrimary {\n        border: 1px solid #E2E7EB;\n        border-radius: 4px;\n        padding: 3px 6px;\n        max-width: 280px;\n\n        &::before {\n            border-style: none !important;\n        }\n\n        &::after {\n            border-style: none !important;\n        }\n\n        svg {\n            padding-left: 5px;\n        }\n\n        input {\n            font-size: 12px;\n            color: #696F88 !important;\n            padding: 3px 0 3px;\n            &::placeholder {\n                color: #696F88 !important;\n                opacity: 0.9;\n                letter-spacing: 0.1px;\n                font-size: 12px;\n            }\n        }\n    }\n}\n\n.date-container {\n    .date-picker-styles {\n        margin: 0px !important;\n        background: #fff;\n        .MuiInputBase-input {\n            padding: 6px 14px;\n            font-size: $font_12;\n            color: $input_text;\n            border-radius: 8px;\n        }\n        .MuiInputBase-root {\n            .MuiOutlinedInput-notchedOutline {\n                border-color: $grey_color;\n            }\n            .MuiInputAdornment-root.MuiInputAdornment-positionEnd{\n                .MuiIconButton-root{\n                    padding: 0px;\n                }\n            }\n        }\n        &.disable-fields{\n            .MuiOutlinedInput-notchedOutline{\n                background: rgb(0 0 0 / 10%);\n                color: rgb(0 0 0 / 60%);\n            }\n        }\n    }\n\n    .MuiFormControl-root {\n        position: relative;\n        .clear-date {\n            display: none;\n        }\n\n        &:hover {\n            .clear-date {\n                display: block;\n                position: absolute;\n                right: 36px;\n                background: transparent;\n                @media only screen and (min-width: 1026px) {\n                bottom: -1px;\n                }\n                @media only screen and (min-width: 1022px) and (max-width: 1025px)  {\n                bottom: 3px;\n                }\n            }\n        }\n    }\n\n}\n\n.btn-txt {\n    text-transform: capitalize !important;\n    // padding: 5px !important;\n}\n.btn-txt-capitalize {\n    text-transform: capitalize !important;\n}\n\n.MuiDialogActions-root {\n    .MuiButton-root {\n        min-height: 40px;\n        height: 40px;\n        border-radius: 8px;\n        font-size: 14px;\n        line-height: 20px;\n        text-transform: none;\n    }\n}\n\n.reset_password {\n    color: #232630;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    word-wrap: break-word;\n    padding-top: 32px;\n\n    ul {\n        li {\n            margin: 5px 0px;\n\n            svg {\n                position: relative;\n                top: 5px;\n                margin-left: 5px;\n                font-size: 17px;\n            }\n        }\n    }\n}\n\n.email-password-success-header {\n    color: black;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 32px;\n    word-wrap: break-word;\n    padding-bottom: 16px;\n    align-items: flex-start;\n}\n\n.email-password-success-content {\n    color: #696F88;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    word-wrap: break-word;\n    padding-bottom: 32px;\n}\n\n.filtr-date-pkr {\n    .MuiStack-root {\n        overflow: hidden;\n\n        .MuiTypography-root {\n            font-size: 12px;\n            font-weight: 400;\n            // padding-top: 1px;\n        }\n    }\n}\n.signup_date{\n    .MuiStack-root {\n\n        .MuiTypography-root {\n            font-size: 12px;\n        }\n    }\n}\n.custom-select-container {\n    .mui-selector {\n        height: 40px;\n\n        .MuiSelect-select {\n            p {\n                font-size: $font_14;\n                color: $input_text;\n            }\n\n            font-size: $font_14;\n            color: $input_text;\n            padding: 9.5px 14px;\n        }\n    }\n}\n\n.filtr-search {\n    .MuiInputBase-root {\n        .MuiOutlinedInput-input {\n            padding: 8px 14px;\n        }\n    }\n}\n\n.MuiPopover-paper {\n    .MuiMenu-list {\n        .select-lebel-text {\n            font-size: $font_14;\n        }\n    }\n}\n\n.custom-menu-class{\n    .MuiPaper-root{\n      .MuiList-root{\n        .MuiMenuItem-root{\n          white-space: break-spaces;\n        }\n      }\n    }\n  }\n.message-error {\n    height: 20%;\n    top: 8px;\n    max-width: 400px;\n    left: 38% !important;\n    right: 20% !important;\n}\n\n// .date-container{\n//     .MuiTypography-root{\n//         color: red;\n//     }\n// }\n\n.disable-fields {\n    // opacity: 0.6;\n    cursor: not-allowed;\n}\n\n@media (max-width:540px){\n    body{\n        input[type=\"text\"],\n    input[type=\"email\"],\n    input[type=\"number\"],\n    input[type=\"password\"],\n    input[type=\"search\"],\n    input[type=\"tel\"],\n    input[type=\"url\"],\n    textarea {\n        // font-size: 16px !important;  /* Minimum font size to prevent zooming on iOS */\n    }\n    }\n}\n\n// .{\n//     padding: 10px;\n//     border: 1px solid $light_border_color;\n//     border-radius: 6px;\n//     margin-top: 8px;\n// }\n.cstBlocksInfo,.cstBlocks{\n    background: #fff;\n    margin-top: 0.5rem;\n    border-radius: 4px;\n    padding: 0.75rem 1.125rem;\n    .MuiInputBase-root{\n        input[type=\"password\"]{\n            padding: 4px 14px;\n        }\n    }\n}\n.cstContactInfo{\n    .select-dropdown {\n        .cstInfoIcon {\n            top:21px;\n        }\n    }\n}\n@media screen and (max-width: 1024px) {\n    .outlined-text-field {\n        .MuiInputLabel-root {\n            font-size: 14px;\n        }\n        .MuiInputBase-root {\n            input[type=\"text\"] {\n                &.MuiInputBase-input {\n                    font-size: 14px;\n                    padding: 10px 12px;\n                }\n            }\n        }\n    }\n    .select-dropdown {\n        .MuiAutocomplete-root {\n            .MuiFormControl-root {\n                .MuiInputBase-formControl {\n                    padding: 6px;\n                }\n            }\n        }\n    }\n    .date-container{\n        .date-picker-styles {\n            .MuiInputBase-input {\n                padding: 9.5px 14px;\n            }\n        }\n    }\n    .filtr-date-pkr {\n        .MuiTypography-root {\n            font-size: 14px;\n        }\n        \n    }\n    .select-dropdown {\n        .MuiAutocomplete-root {\n            .MuiFormControl-root {\n                .MuiInputBase-formControl {\n                    font-size: $font_15;\n                    padding: 7.5px 6px;\n                }\n            }\n        }\n    }\n    .search_feild {\n        .MuiInputBase-colorPrimary {\n            input {\n                font-size: 14px;\n                &::placeholder {\n                    font-size: 14px;\n                }\n            }\n        }\n    }\n    .date-container {\n        .date-picker-styles {\n            .MuiInputBase-input {\n                font-size: $font_14;\n            }\n        }\n    }\n}\n@media screen and (max-width: 520px) {\n    .cstInfoIcon{\n        top: 27px !important;\n    }\n}",":root {\n    --color: #000;\n    // --font-family: \"sans-serif\";\n    // Single source of truth for the app's max BODY content width (page content + non-dashboard\n    // footers, e.g. the createApplication sticky footer). Change this value to resize that column.\n    // See .app-content-shell in form_styles.scss, which reads this variable.\n    --app-max-content-width: 1440px;\n    // Caps the header's CONTENT (.revamp-header in dashboard.scss) and the Dashboard-page footer\n    // (.version-wrapper-dashboard) / IndeterminateLoadingBar.tsx, all of which center/cap at this\n    // width. .revamp-appbar itself (the header's background) stays full viewport width regardless\n    // — it does not read this variable — so the bar's background spans edge-to-edge while its\n    // content stays capped and centered inside it.\n    --app-header-max-width: 1920px;\n}\n\n// Color codes\n// $primary_color: #054E5A;\n$primary_color:  var(--color);\n$page_bg: #F7F7F8;\n$quote-bgColor:#EAF3F5;\n$accordion-bgColor:#F5F6F8;\n$grey_color: #A3A9B9;\n$light_black: #14151C;\n$input_text: #696F88;\n$light_bgcolor: #F3F4F6;\n$color: #A3A9B9;\n$error: #D84315;\n$white_color: #fff;\n$light_background: #F3F4F6;\n$light_border_color: #C2C7D0;\n$label_color: #808080;\n$light_gray:#718899;\n$icon_bg:#DDDEE9;\n$header_bgcolor: #DFE2E7;\n$table_border:#D9D9D9;\n$cards_bg:#F9F9F9;\n$bg_text:#666;\n//Font Family\n$primaryFont:var(--font-family);\n// Font sizes   \n$font_10: 10px;\n$font_11: 11px;\n$font_12: 12px;\n$font_13: 13px;\n$font_14: 14px;\n$font_15: 15px;\n$font_16: 16px;\n$font_18: 18px;\n$font_20: 20px;\n$font_21: 21px;\n$font_22: 22px;\n$font_24: 24px;\n$font_25: 25px;\n$font_26: 26px;\n$font_28: 28px;\n$font_29: 29px;\n$font_30: 30px;\n\n// Font weights\n$font_weight_normal: normal;\n$font_weight_bold: bold;\n$font_weight_medium: Medium;\n$font_weight_300: 300;\n$font_weight_500: 500;\n$font_weight_600: 600;\n$font_weight_700: 700;\n\n// Font Family\n// $robot: 'robotoregular';\n\n// Box shadow\n$box_shadow_1: 0 1px 3px 0 rgba(63, 63, 68, 0.15),\n    0 0 0 1px rgba(63, 63, 68, 0.05);\n$box_shadow_2: 0 0 7px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_3: 0 0 6px 0 rgba(0, 0, 0, 0.27);\n$box_shadow_4: 0 0 0 1px #e4e7eb;\n$box_shadow_5: 0 0 15px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_1: 0 4px 6px 0 rgba(0, 0, 0, 0.06);\n$box_shadow: 2px 4px 16px rgba(50, 98, 149, 0.15);\n\n//Border radius\n$border_4: 4px;\n$border_10: 10px;\n$border_15: 15px;\n$border_100: 100%;\n\n///margin scss \n//------------------\n$margin-5: 5px 5px 5px 5px;\n$margin-10: 10px 10px 10px 10px;\n$margin-15: 15px 15px 15px 15px;\n$margin-10-15: 10px 15px 10px 15px;\n\n//Media quries\n$mobile_breakpoint: 576px;\n$tablet_breakpoint: 768px;\n$laptop_breakpoint: 992px;\n$large_laptop_breakpoint: 1280px;\n$desktop_breakpoint: 1440px;\n$desktop_point: 1024px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
